import { useState } from "react";
import icon1 from "../../../assets/mobile/store/vuesax-linear-filter-search.svg";
import "../../style/mobile/store/MS_Filter.scss";

const MS_Filter = () => {
  const [data] = useState([
    {
      id: 1,
      name: "همه",
      isActive: true,
    },
    {
      id: 2,
      name: "تخفیف خورده",
      isActive: false,
    },
    {
      id: 3,
      name: "رایگان",
      isActive: false,
    },
    {
      id: 4,
      name: "استخدامی",
      isActive: false,
    },
  ]);

  return (
    <div className="MS_Filter">
      <div className="MS_Filter-title-box">
        <img
          src={icon1}
          alt="filter-icon"
          className="MS_Filter-title-box-icon"
        />
        <div className="MS_Filter-title-box-text">دسته‌بندی</div>
      </div>
      <div className="MS_Filter-body">
        {data.map((item) => (
          <div
            key={item.id}
            style={
              item.isActive
                ? {
                    backgroundColor: "#EBF6FF",
                    borderColor: "#2E81E8",
                    color: "#2E81E8",
                  }
                : null
            }
            className="MS_Filter-body-item"
          >
            {item.name}
          </div>
        ))}
      </div>
    </div>
  );
};

export default MS_Filter;
